<template>
  <div>
    <table class="table table-striped table-bordered table-hover" id="data-table">
      <thead>
        <slot name="columns"></slot>
      </thead>
      <tbody>
        <slot name="rows"></slot>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: [
    'data',
    'pageLength'
  ],
  mounted () {
    $('#data-table').on('draw.dt', function () {
      $(this).find('.dataTables_empty').parents('tbody').empty()
    }).DataTable()

    $('#data-table').on('order.dt', function () {
      // let order = $('#data-table').dataTable().api().order() // this has column and order details
      // console.log(order)
      /*
      $('#data-table').dataTable({
        'ajax': {
          'url': '/pbn/list?', // to be replace with the actual endpoint
          'type': 'POST',
          'data': order
        }
      }) */
    })
  },
  watch: {
    data () {
      $('#data-table').DataTable().destroy()
      this.$nextTick(() => {
        $('#data-table').DataTable({
          pageLength: this.pageLength ? this.pageLength : 100
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Helpers/Table/aDataTable.vue